import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import { errorTracking, checkSessionExpired, refreshJWT, rejectErrors } from './middlewares';
import { composeWithDevTools } from 'remote-redux-devtools';
import * as Sentry from '@sentry/react';

/** - Install composeWithDevTools -
 * This tool is used to debug redux using the remote devtools. Prior to
 * using this tool, developing for mobile on local dev would not be
 * possible as the screen would just be blank. This happens because when
 * webpack runs in development mode it expects to see the redux devtools
 * installed.
 * With this tool installed, we can check whether the environment is
 * running in development or not. If in development, check whether the
 * redux devtools are mounted on the window object. If not, use the
 * composeWithDevTools to allow remote debuggin.
 */

import rootReducer from '../reducers';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({});

export default function configureStore({ history }) {
  const router = routerMiddleware(history);
  const middlewares = applyMiddleware(router, thunk, checkSessionExpired,
    errorTracking, refreshJWT, rejectErrors);

  let finalCreateStore = null;
  if (process.env.NODE_ENV === 'development'
    /* eslint-disable */
    && window.__REDUX_DEVTOOLS_EXTENSION__) {
    /* eslint-enable */
    finalCreateStore = compose(
      middlewares,
      /* eslint-disable */
      window.__REDUX_DEVTOOLS_EXTENSION__({ trace: true, traceLimit: 25 }),
      /* eslint-enable */
    )(createStore);
  } else if (process.env.NODE_ENV === 'development') {
    finalCreateStore = composeWithDevTools(middlewares)(createStore);
  } else {
    finalCreateStore = compose(middlewares, sentryReduxEnhancer)(createStore);
  }

  const store = finalCreateStore(rootReducer);

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextReducer = require('../reducers').default; // eslint-disable-line global-require

      store.replaceReducer(nextReducer);
    });
  }

  return store;
}



// WEBPACK FOOTER //
// ./client/app/store/configureStore.js